// Redux Tickettypes module
// see https://github.com/erikras/ducks-modular-redux

import { change } from 'redux-form';
import { Tickettypes, Utils } from '../../services/';
import { make_temporary_pricing_id } from '../../services/entityIdFromName';
import { merge_pricings_for_form_sync } from '../../services/syncFormPricings';
import { seed_first_tickettype_pricing } from '../../services/seedTickettypePricing';
import * as _ from 'es-toolkit';

const TICKETTYPE_FORM = 'tickettypeForm';

const sync_tickettype_form_pricings = (dispatch, getState, renamed) => {
    const reducer_pricings = getState().tickettypes?.tickettype?.pricings || {};
    const form_pricings = getState().form?.[TICKETTYPE_FORM]?.values?.pricings || {};
    dispatch(change(
        TICKETTYPE_FORM,
        'pricings',
        merge_pricings_for_form_sync(form_pricings, reducer_pricings, renamed)
    ));
};

// Same keepDirtyOnReinitialize issue as pricings: UI lists come from the
// reducer, but submit merges form values on top — drop removed keys here.
const sync_tickettype_form_emails = (dispatch, getState) => {
    const reducer_emails = getState().tickettypes?.tickettype?.opaque?.emails || {};
    const form_emails = getState().form?.[TICKETTYPE_FORM]?.values?.opaque?.emails || {};
    dispatch(change(
        TICKETTYPE_FORM,
        'opaque.emails',
        merge_pricings_for_form_sync(form_emails, reducer_emails)
    ));
};

const sync_tickettype_form_layout_overrides = (dispatch, getState) => {
    const reducer_overrides = getState().tickettypes?.tickettype?.opaque?.layouts?.overrides || {};
    const form_overrides = getState().form?.[TICKETTYPE_FORM]?.values?.opaque?.layouts?.overrides || {};
    dispatch(change(
        TICKETTYPE_FORM,
        'opaque.layouts.overrides',
        merge_pricings_for_form_sync(form_overrides, reducer_overrides)
    ));
};

// Same keepDirtyOnReinitialize issue as layouts: submit merges form on top of
// the reducer, so removed stock overrides must be dropped from the form too.
const sync_tickettype_form_stocks_overrides = (dispatch, getState, renamed) => {
    const reducer_overrides = getState().tickettypes?.tickettype?.rules?.stocks?.overrides || {};
    const form_overrides = getState().form?.[TICKETTYPE_FORM]?.values?.rules?.stocks?.overrides || {};
    dispatch(change(
        TICKETTYPE_FORM,
        'rules.stocks.overrides',
        merge_pricings_for_form_sync(form_overrides, reducer_overrides, renamed)
    ));
};

const sync_tickettype_form_fields = (dispatch, getState) => {
    const reducer_fields = getState().tickettypes?.tickettype?.opaque?.fields || {};
    const form_fields = getState().form?.[TICKETTYPE_FORM]?.values?.opaque?.fields || {};
    dispatch(change(
        TICKETTYPE_FORM,
        'opaque.fields',
        merge_pricings_for_form_sync(form_fields, reducer_fields)
    ));
};

const RESET_TICKETTYPE                   = 'kronos/tickettypes/RESET_TICKETTYPE';
const LOADING_TICKETTYPES                = 'kronos/tickettypes/LOADING_TICKETTYPES';
const LOADING_TICKETTYPES_SUCCESS        = 'kronos/tickettypes/LOADING_TICKETTYPES_SUCCESS';
const LOADING_TICKETTYPES_FAILURE        = 'kronos/tickettypes/LOADING_TICKETTYPES_FAILURE';
const LOADING_TICKETTYPE                 = 'kronos/tickettypes/LOADING_TICKETTYPE';
const LOADING_TICKETTYPE_SUCCESS         = 'kronos/tickettypes/LOADING_TICKETTYPE_SUCCESS';
const LOADING_TICKETTYPE_FAILURE         = 'kronos/tickettypes/LOADING_TICKETTYPE_FAILURE';
const UPDATING_TICKETTYPE                = 'kronos/tickettypes/UPDATING_TICKETTYPE';
const UPDATING_TICKETTYPE_SUCCESS        = 'kronos/tickettypes/UPDATING_TICKETTYPE_SUCCESS';
const UPDATING_TICKETTYPE_FAILURE        = 'kronos/tickettypes/UPDATING_TICKETTYPE_FAILURE';
const START_CREATING_TICKETTYPE          = 'kronos/tickettypes/START_CREATING_TICKETTYPE';
const CREATING_TICKETTYPE                = 'kronos/tickettypes/CREATING_TICKETTYPE';
const CREATING_TICKETTYPE_SUCCESS        = 'kronos/tickettypes/CREATING_TICKETTYPE_SUCCESS';
const CREATING_TICKETTYPE_FAILURE        = 'kronos/tickettypes/CREATING_TICKETTYPE_FAILURE';
const DELETING_TICKETTYPE                = 'kronos/tickettypes/DELETING_TICKETTYPE';
const DELETING_TICKETTYPE_SUCCESS        = 'kronos/tickettypes/DELETING_TICKETTYPE_SUCCESS';
const DELETING_TICKETTYPE_FAILURE        = 'kronos/tickettypes/DELETING_TICKETTYPE_FAILURE';
const ADDING_PRICING                     = 'kronos/tickettypes/ADDING_PRICING';
const DUPLICATING_PRICING                = 'kronos/tickettypes/DUPLICATING_PRICING';
const REMOVING_PRICING                   = 'kronos/tickettypes/REMOVING_PRICING';
const UPDATING_PRICINGS_KEYS             = 'kronos/tickettypes/UPDATING_PRICINGS_KEYS';
const ADDING_WINDOW                      = 'kronos/tickettypes/ADDING_WINDOW';
const REMOVING_WINDOW                    = 'kronos/tickettypes/REMOVING_WINDOW';
const UPDATING_WINDOWS                   = 'kronos/tickettypes/UPDATING_WINDOWS';
const ADDING_FIELDS                      = 'kronos/tickettypes/ADDING_FIELDS';
const REMOVING_FIELDS                    = 'kronos/tickettypes/REMOVING_FIELDS';
const ADDING_LAYOUT                      = 'kronos/tickettypes/ADDING_LAYOUT';
const REMOVING_LAYOUT                    = 'kronos/tickettypes/REMOVING_LAYOUT';
const ADDING_STOCK_OVERRIDE              = 'kronos/tickettypes/ADDING_STOCK_OVERRIDE';
const REMOVING_STOCK_OVERRIDE            = 'kronos/tickettypes/REMOVING_STOCK_OVERRIDE';
const RENAMING_STOCK_OVERRIDE            = 'kronos/tickettypes/RENAMING_STOCK_OVERRIDE';
const CLEARING_PRICING_RULES_OVERRIDE    = 'kronos/tickettypes/CLEARING_PRICING_RULES_OVERRIDE';
const ADDING_EMAIL_LAYOUT                = 'kronos/tickettypes/ADDING_EMAIL_LAYOUT';
const REMOVING_EMAIL_LAYOUT              = 'kronos/tickettypes/REMOVING_EMAIL_LAYOUT';
const UPDATING_TICKETTYPE_PRICINGS       = 'kronos/tickettypes/UPDATING_TICKETTYPE_PRICINGS';
const UPDATING_TICKETTYPES_ORDER         = 'kronos/tickettypes/UPDATING_TICKETTYPES_ORDER';
const UPDATING_TICKETTYPES_ORDER_SUCCESS = 'kronos/tickettypes/UPDATING_TICKETTYPES_ORDER_SUCCESS';
const UPDATING_TICKETTYPES_ORDER_FAILURE = 'kronos/tickettypes/UPDATING_TICKETTYPES_ORDER_FAILURE';
const DUPLICATING_TICKETTYPE             = 'kronos/pricinglists/DUPLICATING_TICKETTYPE';
const DUPLICATING_TICKETTYPE_SUCCESS     = 'kronos/pricinglists/DUPLICATING_TICKETTYPE_SUCCESS';
const DUPLICATING_TICKETTYPE_FAILURE     = 'kronos/pricinglists/DUPLICATING_TICKETTYPE_FAILURE';
const LOADING_TICKETTYPES_REFS           = 'kronos/tickettypes/LOADING_TICKETTYPES_REFS';
const LOADING_TICKETTYPES_REFS_SUCCESS   = 'kronos/tickettypes/LOADING_TICKETTYPES_REFS_SUCCESS';
const LOADING_TICKETTYPES_REFS_FAILURE   = 'kronos/tickettypes/LOADING_TICKETTYPES_REFS_FAILURE';


const initialState = {
    isLoading: false,
    hasLoadingError: false,
    loadingErrorMessage: '',
    tickettypeSuccessfullyCreated: false,
    tickettypeSuccessfullyDeleted: false,
    duplicatedTickettype: {},
    tickettypes: [],
    tickettype: {},
    refs: [],
}

const defaultFields = {
    "requested": [],
    "required": []
};

const initialPricing = (names, currency, vat, eshopWeight, idiv) => {
    const pricing = {
        name: names,
        // Empty strings keep Field paths bound without prefilling "0".
        price: { [currency]: '' },
        value: { [currency]: '' },
        value_per_screening: { [currency]: '' },
        wallet_amount: { [currency]: '' },
        variable_price: false,
        value_like_price: true,
        VAT: vat || 0,
        posters: [],
        rules: {
            only_for_roles: Utils.defaultPricingSellerRoles(),
        },
        opaque: {
            eshop_sort_weight: eshopWeight
        }
    };
    // Only seed iDIV when the instance has a local rate; seeding 0 makes
    // PricingForm show the field (idiv !== undefined) on tax.local = 0.
    if (Number(idiv) > 0)
        pricing.idiv = Number(idiv);
    return pricing;
}

// Reducer
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case RESET_TICKETTYPE:
            return {
                ...state,
                tickettype: {},
                isLoading: false,
                hasLoadingError: false,
            };
        case LOADING_TICKETTYPES:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case LOADING_TICKETTYPES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                tickettypes: action.tickettypes,
                tickettypeSuccessfullyCreated: false,
                tickettypeSuccessfullyDeleted: false
            };
        case LOADING_TICKETTYPES_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message,
                tickettypeSuccessfullyCreated: false,
                tickettypeSuccessfullyDeleted: false
            };
        case LOADING_TICKETTYPES_REFS:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case LOADING_TICKETTYPES_REFS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                refs: action.refs,
            };
        case LOADING_TICKETTYPES_REFS_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message,
            };
        case LOADING_TICKETTYPE:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case LOADING_TICKETTYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                tickettype: action.tickettype
            };
        case LOADING_TICKETTYPE_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case UPDATING_TICKETTYPE:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case UPDATING_TICKETTYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                tickettype: action.tickettype
            };
        case UPDATING_TICKETTYPE_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case START_CREATING_TICKETTYPE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                tickettypeSuccessfullyCreated: false,
                // Ensure sane default tickettype for creation
                tickettype: {
                    "name": {},
                    "pricings": {},
                    "opaque": {
                        "fields": {
                            "default": defaultFields
                        }
                    }

                }
            };
        case CREATING_TICKETTYPE:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case CREATING_TICKETTYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                tickettypeSuccessfullyCreated: true,
                tickettype: action.tickettype
            };
        case CREATING_TICKETTYPE_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                tickettypeSuccessfullyCreated: false,
                loadingErrorMessage: action.error.message
            };
        case DELETING_TICKETTYPE:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case DELETING_TICKETTYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                tickettypeSuccessfullyDeleted: true,
                tickettype: null
            };
        case DELETING_TICKETTYPE_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                tickettypeSuccessfullyDeleted: false,
                loadingErrorMessage: action.error.message
            };
        case ADDING_PRICING:
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    pricings: {
                        ...state.tickettype.pricings,
                        [make_temporary_pricing_id()]: initialPricing(action.names, action.currency, action.vat, Object.keys(state.tickettype.pricings).length + 1, action.idiv)
                    }
                }
            };
        case DUPLICATING_PRICING: {
            const source = state.tickettype.pricings?.[action._id];
            if (!source)
                return state;
            const new_id = String(Date.now());
            const cloned = _.cloneDeep(source);
            if (!cloned.opaque)
                cloned.opaque = {};
            cloned.opaque.eshop_sort_weight = Object.keys(state.tickettype.pricings).length + 1;
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    pricings: {
                        ...state.tickettype.pricings,
                        [new_id]: cloned
                    }
                }
            };
        }
        case REMOVING_PRICING:
            const { [action._id]: toRemove, ...otherPricings } = state.tickettype.pricings;
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    pricings: otherPricings
                }
            };
        case UPDATING_PRICINGS_KEYS:
            let temp = _.cloneDeep(state.tickettype.pricings);
            if (temp[action.values.newId]) {
                return {
                    ...state
                }
            }
            else {
                temp[action.values.newId] = {
                    ...temp[action.values.oldId],
                    ...(action.values.pricing_patch || {}),
                };
                delete temp[action.values.oldId];

                return {
                    ...state,
                    tickettype: {
                        ...state.tickettype,
                        pricings: temp
                    }
                }
            }
        case ADDING_WINDOW:
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    windows: (state.tickettype.windows || []).concat([{
                        nsame_screening: 1, // default value
                        nbookings: 1,       // default value
                        same_day: false     // default value
                    }])
                }
            };
        case REMOVING_WINDOW:
            const new_windows = _.cloneDeep(state.tickettype.windows);
            new_windows.splice(action.idx, 1);
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    windows: new_windows
                }
            };
        case UPDATING_WINDOWS:
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    windows: action.windows
                }
            };
        case ADDING_FIELDS:
            const fields = (
                ('fields' in state.tickettype.opaque) && (Object.keys(state.tickettype.opaque.fields).length > 0) ?
                    state.tickettype.opaque.fields : {}
            );
            fields[action.idx] = defaultFields;

            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    opaque: {
                        ...state.tickettype.opaque,
                        fields
                    }
                }
            };
        case REMOVING_FIELDS:
            const { [action.idx]: fieldToRemove, ...otherFields } = state.tickettype.opaque.fields;
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    opaque: {
                        ...state.tickettype.opaque,
                        fields: otherFields
                    }
                }
            };
        case ADDING_LAYOUT: {
            const opaque = state.tickettype.opaque || {};
            const layouts = opaque.layouts || {};
            const overrides = layouts.overrides || {};
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    opaque: {
                        ...opaque,
                        layouts: {
                            ...layouts,
                            overrides: {
                                ...overrides,
                                [action.idx]: {},
                            },
                        },
                    },
                },
            };
        }
        case REMOVING_LAYOUT: {
            const opaque = state.tickettype.opaque || {};
            const layouts = opaque.layouts || {};
            const { [action.idx]: _removed, ...overrides } = layouts.overrides || {};
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    opaque: {
                        ...opaque,
                        layouts: {
                            ...layouts,
                            overrides,
                        },
                    },
                },
            };
        }
        case ADDING_STOCK_OVERRIDE: {
            const rules = state.tickettype.rules || {};
            const stocks = rules.stocks || {};
            const overrides = { ...(stocks.overrides || {}), [action.idx]: {} };
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    rules: {
                        ...rules,
                        stocks: {
                            ...stocks,
                            overrides,
                        },
                    },
                },
            };
        }
        case REMOVING_STOCK_OVERRIDE: {
            const rules = state.tickettype.rules || {};
            const stocks = rules.stocks || {};
            const stockOverrides = { ...(stocks.overrides || {}) };
            delete stockOverrides[action.idx];
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    rules: {
                        ...rules,
                        stocks: {
                            ...stocks,
                            overrides: stockOverrides,
                        },
                    },
                },
            };
        }
        case RENAMING_STOCK_OVERRIDE: {
            const { oldId, newId } = action.values;
            const rules = state.tickettype.rules || {};
            const stocks = rules.stocks || {};
            const renamedOverrides = { ...(stocks.overrides || {}) };
            if (!(oldId in renamedOverrides) || newId in renamedOverrides)
                return state;
            renamedOverrides[newId] = renamedOverrides[oldId];
            delete renamedOverrides[oldId];
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    rules: {
                        ...rules,
                        stocks: {
                            ...stocks,
                            overrides: renamedOverrides,
                        },
                    },
                },
            };
        }
        case CLEARING_PRICING_RULES_OVERRIDE: {
            if (!state.tickettype.pricings?.[action.idx])
                return state;
            // Missing only_for_roles inherits tickettype defaults (or unrestricted).
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    pricings: {
                        ...state.tickettype.pricings,
                        [action.idx]: {
                            ...state.tickettype.pricings[action.idx],
                            rules: {},
                        }
                    }
                }
            };
        }
        case ADDING_EMAIL_LAYOUT: {
            const opaque = state.tickettype.opaque || {};
            const emails = opaque.emails || {};
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    opaque: {
                        ...opaque,
                        emails: {
                            ...emails,
                            [action.idx]: {
                                activation: null,
                                creation: null,
                            },
                        },
                    },
                },
            };
        }
        case REMOVING_EMAIL_LAYOUT: {
            const opaque = state.tickettype.opaque || {};
            const { [action.idx]: _removed, ...emails } = opaque.emails || {};
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    opaque: {
                        ...opaque,
                        emails,
                    },
                },
            };
        }
        case UPDATING_TICKETTYPE_PRICINGS:
            return {
                ...state,
                tickettype: {
                    ...state.tickettype,
                    pricings: action.pricings
                }
            };
        case UPDATING_TICKETTYPES_ORDER:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false
            };
        case UPDATING_TICKETTYPES_ORDER_SUCCESS:
            return {
                ...state,
                tickettypes: [
                    ...state.tickettypes
                ],
                isLoading: false,
                hasLoadingError: false,
                tickettype: action.tickettype
            };
        case UPDATING_TICKETTYPES_ORDER_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case DUPLICATING_TICKETTYPE:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false,
            };
        case DUPLICATING_TICKETTYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                duplicatedTickettype: action.tickettype
            };
        case DUPLICATING_TICKETTYPE_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        default:
            return state;
    }
};

// Actions
function loadingTickettypes() { return { type: LOADING_TICKETTYPES } }
function loadingTickettypesSuccess(tickettypes) { return { type: LOADING_TICKETTYPES_SUCCESS, tickettypes: tickettypes } }
function loadingTickettypesFailure(err) { return { type: LOADING_TICKETTYPES_FAILURE, error: err } }
export function loadTickettypes(_tickettypename, _password) {
    return (dispatch) => {
        dispatch(loadingTickettypes());
        Tickettypes.list()
            .then(data => {
                const tickettypes = data.tickettypes;
                dispatch(loadingTickettypesSuccess(tickettypes));
            })
            .catch(err => {
                console.log("err => ", err);
                dispatch(loadingTickettypesFailure(err))
            });
    }
}

function loadingTickettypesRefs() { return { type: LOADING_TICKETTYPES_REFS } }
function loadingTickettypesRefsSuccess(refs) { return { type: LOADING_TICKETTYPES_REFS_SUCCESS, refs } }
function loadingTickettypesRefsFailure(err) { return { type: LOADING_TICKETTYPES_REFS_FAILURE, error: err } }
export function loadTickettypesRefs() {
    return (dispatch) => {
        dispatch(loadingTickettypesRefs());
        Tickettypes.loadRefs()
            .then(data => {
                const refs = data.refs;
                dispatch(loadingTickettypesRefsSuccess(refs));
            })
            .catch(err => {
                console.log("err => ", err);
                dispatch(loadingTickettypesRefsFailure(err))
            });
    }
}

export function resetTickettype() { return { type: RESET_TICKETTYPE } }
function loadingTickettype() { return { type: LOADING_TICKETTYPE } }
function loadingTickettypeSuccess(tickettype) { return { type: LOADING_TICKETTYPE_SUCCESS, tickettype: tickettype } }
function loadingTickettypeFailure(err) { return { type: LOADING_TICKETTYPE_FAILURE, error: err } }
export function loadTickettype(tickettypeId) {
    return (dispatch) => {
        dispatch(loadingTickettype());
        Tickettypes.get(tickettypeId)
            .then(data => {
                const tickettype = data.tickettype;
                dispatch(loadingTickettypeSuccess(tickettype));
            })
            .catch(err => {
                dispatch(loadingTickettypeFailure(err))
            });
    }
}

function updatingTickettype() { return { type: UPDATING_TICKETTYPE } }
function updatingTickettypeSuccess(tickettype) { return { type: UPDATING_TICKETTYPE_SUCCESS, tickettype: tickettype } }
function updatingTickettypeFailure(err) { return { type: UPDATING_TICKETTYPE_FAILURE, error: err } }
export function updateTickettype(tickettype) {
    return (dispatch) => {
        dispatch(updatingTickettype());
        Tickettypes.update(tickettype)
            .then(data => {
                const tickettype = data.tickettype;
                dispatch(updatingTickettypeSuccess(tickettype));
            })
            .catch(err => {
                dispatch(updatingTickettypeFailure(err))
            });
    }
}

function creatingTickettype() { return { type: CREATING_TICKETTYPE } }
function creatingTickettypeSuccess(tickettype) { return { type: CREATING_TICKETTYPE_SUCCESS, tickettype: tickettype } }
function creatingTickettypeFailure(err) { return { type: CREATING_TICKETTYPE_FAILURE, error: err } }
export function startCreateTickettype() { return { type: START_CREATING_TICKETTYPE } }
export function createTickettype(tickettype) {
    return (dispatch) => {
        dispatch(creatingTickettype());
        const payload = seed_first_tickettype_pricing(tickettype, {
            currency: Utils.currency(),
            vat: Utils.tax()?.vat_tickets ?? 0,
            idiv: Utils.tax()?.local ?? 0,
            initialPricing,
        });
        Tickettypes.create(payload)
            .then(data => {
                const tickettype = data.tickettype;
                dispatch(creatingTickettypeSuccess(tickettype));
                dispatch(loadingTickettypeSuccess(tickettype));
            })
            .catch(err => {
                dispatch(creatingTickettypeFailure(err))
            });
    }
}

function deletingTickettype() { return { type: DELETING_TICKETTYPE } }
function deletingTickettypeSuccess() { return { type: DELETING_TICKETTYPE_SUCCESS } }
function deletingTickettypeFailure(err) { return { type: DELETING_TICKETTYPE_FAILURE, error: err } }
export function deleteTickettype(tickettypeId) {
    return (dispatch) => {
        dispatch(deletingTickettype());
        Tickettypes.delete(tickettypeId)
            .then(() => {
                dispatch(deletingTickettypeSuccess());
            })
            .catch(err => {
                dispatch(deletingTickettypeFailure(err))
            });
    }
}

function addingPricing(names, currency) {
    const vat = Utils.tax()?.vat_tickets ?? 0;
    const idiv = Utils.tax()?.local ?? 0;
    return { type: ADDING_PRICING, names, currency, vat, idiv }
}
export function addPricing(names, currency) {
    return (dispatch, getState) => {
        dispatch(addingPricing(names, currency));
        // keepDirtyOnReinitialize does not inject new nested keys into the form.
        sync_tickettype_form_pricings(dispatch, getState);
    }
}

function duplicatingPricing(_id) { return { type: DUPLICATING_PRICING, _id } }
export function duplicatePricing(_id) {
    return (dispatch, getState) => {
        dispatch(duplicatingPricing(_id));
        sync_tickettype_form_pricings(dispatch, getState);
    }
}

function removingPricing(_id) { return { type: REMOVING_PRICING, _id } }
export function removePricing(_id) {
    return (dispatch, getState) => {
        dispatch(removingPricing(_id));
        sync_tickettype_form_pricings(dispatch, getState);
    }
}

function updatingPricingsKeys(values) { return { type: UPDATING_PRICINGS_KEYS, values } }
export function updatePricingsKeys(values) {
    return (dispatch, getState) => {
        dispatch(updatingPricingsKeys(values));
        sync_tickettype_form_pricings(dispatch, getState, {
            oldId: values?.oldId,
            newId: values?.newId,
        });
    }
}

function addingWindow() { return { type: ADDING_WINDOW } }
export function addWindow() {
    return (dispatch) => {
        dispatch(addingWindow());
    }
}

function removingWindow(idx) { return { type: REMOVING_WINDOW, idx } }
export function removeWindow(idx) {
    return (dispatch) => {
        dispatch(removingWindow(idx));
    }
}

function updatingWindows(windows) { return { type: UPDATING_WINDOWS, windows } }
export function updateTickettypeWindows(windows) {
    return (dispatch) => {
        dispatch(updatingWindows(windows));
    }
}

function addingFields(idx) { return { type: ADDING_FIELDS, idx } }
export function addFields(idx) {
    return (dispatch, getState) => {
        dispatch(addingFields(idx));
        sync_tickettype_form_fields(dispatch, getState);
    }
}

function removingFields(idx) { return { type: REMOVING_FIELDS, idx } }
export function removeFields(idx) {
    return (dispatch, getState) => {
        dispatch(removingFields(idx));
        sync_tickettype_form_fields(dispatch, getState);
    }
}

function addingLayout(idx) { return { type: ADDING_LAYOUT, idx } }
export function addLayout(idx) {
    return (dispatch, getState) => {
        dispatch(addingLayout(idx));
        sync_tickettype_form_layout_overrides(dispatch, getState);
    }
}

function removingLayout(idx) { return { type: REMOVING_LAYOUT, idx } }
export function removeLayout(idx) {
    return (dispatch, getState) => {
        dispatch(removingLayout(idx));
        sync_tickettype_form_layout_overrides(dispatch, getState);
    }
}

function addingStockOverride(idx) { return { type: ADDING_STOCK_OVERRIDE, idx } }
export function addStockOverride(idx) {
    return (dispatch, getState) => {
        dispatch(addingStockOverride(idx));
        sync_tickettype_form_stocks_overrides(dispatch, getState);
    }
}

function removingStockOverride(idx) { return { type: REMOVING_STOCK_OVERRIDE, idx } }
export function removeStockOverride(idx) {
    return (dispatch, getState) => {
        dispatch(removingStockOverride(idx));
        sync_tickettype_form_stocks_overrides(dispatch, getState);
    }
}

function renamingStockOverride(values) { return { type: RENAMING_STOCK_OVERRIDE, values } }
export function renameStockOverride(values) {
    return (dispatch, getState) => {
        dispatch(renamingStockOverride(values));
        sync_tickettype_form_stocks_overrides(dispatch, getState, values);
    }
}

function clearingPricingRulesOverride(idx) { return { type: CLEARING_PRICING_RULES_OVERRIDE, idx } }
export function clearPricingRulesOverride(idx) {
    return (dispatch) => {
        dispatch(clearingPricingRulesOverride(idx));
    }
}

function addingEmailLayout(idx) { return { type: ADDING_EMAIL_LAYOUT, idx } }
export function addEmailLayout(idx) {
    return (dispatch, getState) => {
        dispatch(addingEmailLayout(idx));
        sync_tickettype_form_emails(dispatch, getState);
    }
}

function removingEmailLayout(idx) { return { type: REMOVING_EMAIL_LAYOUT, idx } }
export function removeEmailLayout(idx) {
    return (dispatch, getState) => {
        dispatch(removingEmailLayout(idx));
        sync_tickettype_form_emails(dispatch, getState);
    }
}

function updatingTickettypePricings(pricings) { return { type: UPDATING_TICKETTYPE_PRICINGS, pricings } }
export function updateTickettypePricings(pricings) {
    return (dispatch) => {
        dispatch(updatingTickettypePricings(pricings));
    }
}

function duplicatingTickettype() { return { type: DUPLICATING_TICKETTYPE } }
function duplicatingTickettypeSuccess(tickettype) { return { type: DUPLICATING_TICKETTYPE_SUCCESS, tickettype: tickettype } }
function duplicatingTickettypeFailure(err) { return { type: DUPLICATING_TICKETTYPE_FAILURE, error: err } }
export function duplicateTickettype(tickettype, newId) {
    return (dispatch) => {
        dispatch(duplicatingTickettype());
        Tickettypes.duplicate(tickettype, newId)
            .then(data => {
                dispatch(duplicatingTickettypeSuccess(data.tickettype));
            })
            .catch(err => {
                dispatch(duplicatingTickettypeFailure(err))
            });
    }
}
